import { S } from '../strings';
import type { ParsedItem } from '../types';
import { UpdateCard } from './UpdateCard';

export interface PriorityListViewProps {
  // Pre-sorted (by impact) caller-side. The view renders in the order
  // received — keeps the view dumb and the sort colocated with the filter
  // memos in the shell.
  items: ParsedItem[];
  isBookmarked: (id: string) => boolean;
  onToggleBookmark: (item: ParsedItem) => void;
  isMuted?: (id: string) => boolean;
  onToggleMute?: (item: ParsedItem) => void;
}

export function PriorityListView({
  items,
  isBookmarked,
  onToggleBookmark,
  isMuted,
  onToggleMute,
}: PriorityListViewProps) {
  return (
    <div style={{ maxWidth: 860 }}>
      {items.map((item, i) => (
        <UpdateCard
          key={item.id}
          item={item}
          style={{ animationDelay: `${i * 0.03}s` }}
          bookmarked={isBookmarked(item.id)}
          onToggleBookmark={() => onToggleBookmark(item)}
          muted={isMuted?.(item.id)}
          onToggleMute={onToggleMute}
        />
      ))}
      {items.length === 0 && (
        <div style={{ textAlign: 'center', padding: 60, color: 'var(--text-muted)' }}>
          {S.emptyPanel}
        </div>
      )}
    </div>
  );
}
